// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zFmrw","problemWrapper":"styles_problemWrapper__Is++Q","userWrapper":"styles_userWrapper__euR-K"};